import _ from 'lodash';
import React, { useState, useContext } from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Validator } from 'blaze-validator';
import toastr from '../toastr';
import { modal } from '../modal/ModalEmitter';
import FileNotFound from '../FileNotFound';
import LoyaltyContext from './LoyaltyContext';
import ModalContext from '../modal/ModalContext';

const OfferList = ({
  customerId,
  initialOffersSelected = [],
  invoiceNumber = '1337',
  onQueryClick = () => {},
  onSelect,
  query = [],
  params = {},
}) => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [showPagination, setShowPagination] = useState(false);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(-1);
  const [error, setError] = useState('');
  const [selected, setSelected] = useState({});
  const [redeeming, setRedeeming] = useState(false);

  const { fetchPublicOffers, fetchCustomerOffers, redeem } = useContext(LoyaltyContext);
  const { setTitle } = useContext(ModalContext);
  const selectedCount = Object.keys(selected).length;

  const prepareSelectedOffers = () => {
    const redemptions = [];

    Object.keys(selected).forEach(offerId => {
      const offer = selected[offerId];
      const redemption = {
        invoiceNumber,
        void: false,
        couponCode: offer.CouponCode,
        OfferUniqueId: offer.OfferUniqueId,
        PartNumber: '',
      };

      if (params.partNumbers) {
        const parts = params.partNumbers.split(',');

        if (parts.length) {
          let usePart;
          parts.forEach(part => {
            if (offer.PartNumbers.includes(part)) {
              usePart = part;
            }
          });

          redemption.PartNumber = usePart;
        }
      }

      redemptions.push(redemption);
    });

    return redemptions;
  };

  const onRedeem = () => {
    setRedeeming(true);
    const redemptions = prepareSelectedOffers();

    redeem(customerId, redemptions)
      .then(response => {
        // toastr.success(`Redeemed ${redemptions.length} coupon${redemptions.length > 1 ? 's' : ''}`);
      })
      .catch(error => {
        toastr.error(_.get(error, 'response.data.error'));
      })
      .finally(() => {
        setRedeeming(false);
      });
  };

  const toggleRow = offer => {
    const offerId = offer.OfferUniqueId;
    const newSelected = { ...selected };

    if (selected[offerId]) {
      delete newSelected[offerId];
    } else {
      // Check for one unique offer by part
      // 5296,C81-6022,C81-1013,02-01846,JA11100,E006-185  (5296 on multiple offers)
      const selectedOffers = Object.keys(selected).map(offerId => selected[offerId]);
      const offerWithSamePart = selectedOffers.find(selectedOffer => {
        if (selectedOffer.PartNumbers && Array.isArray(selectedOffer.PartNumbers)) {
          return selectedOffer.PartNumbers.find(s => {
            if (offer.PartNumbers && Array.isArray(offer.PartNumbers)) {
              return offer.PartNumbers.find(o => o.toUpperCase() === s.toUpperCase());
            }

            return null;
          });
        }

        return null;
      });

      if (offerWithSamePart && newSelected[offerWithSamePart.OfferUniqueId]) {
        // if (newSelected[offerWithSamePart.OfferUniqueId].applicableParts.length === 1) {
        delete newSelected[offerWithSamePart.OfferUniqueId];
        // }
      }

      newSelected[offerId] = offer;
    }

    setSelected(newSelected);
  };

  const getSelectedAmount = () => {
    let amount = 0;
    if (!selectedCount) {
      return amount;
    }

    Object.keys(selected).forEach(offerId => {
      const offer = selected[offerId];
      amount += offer.Amount;
    });

    return amount;
  };

  const columns = [
    {
      id: 'checkbox',
      accessor: '',
      Cell: row => {
        return (
          <input
            type="checkbox"
            className="checkbox"
            checked={!!selected[row.original.OfferUniqueId]}
            onChange={() => {
              toggleRow(row.original);
            }}
          />
        );
      },
      sortable: false,
      width: 30,
      className: 'text-center sticky',
      Header: '',
      headerClassName: 'sticky',
    },
    {
      Header: '',
      width: 50,
      className: 'text-center',
      Cell: row => {
        return (
          <ButtonGroup>
            <Button
              onClick={() => {
                modal.open('loyaltyOffer', { offerId: row.original.OfferUniqueId, headerClass: 'primary' });
              }}
              size="xs"
              title="View Offer"
            >
              View
            </Button>
          </ButtonGroup>
        );
      },
    },
    { Header: 'Offer ID', accessor: 'OfferUniqueId', show: false },
    {
      Header: 'Amount',
      accessor: 'Amount',
      className: 'amount',
      Cell: row => {
        return (
          <div className="amount">
            {Validator.sanitize('number', row.original.Amount, { precision: 2 })} {row.original.Currency}
          </div>
        );
      },
    },
    {
      Header: 'Part',
      accessor: 'PartNumbers',
      className: 'text-center',
      Cell: row => {
        const partsOnOffer = row.original.PartNumbers;

        // User did not narrow down parts
        if (!params.partNumbers) {
          if (partsOnOffer.length > 1) {
            return (
              <div className="part">
                <i>{partsOnOffer.length} parts</i>
              </div>
            );
          } else {
            return <div className="part">{partsOnOffer[0]}</div>;
          }
        }

        const searchedParts = params.partNumbers ? params.partNumbers.split(',') : [];

        // Find part from query that matches one in list of offers
        // JA11100,E006-185
        const applicableParts = partsOnOffer.filter(p => {
          return searchedParts.includes(p.toUpperCase());
        });

        // Might be possible bond still wants us to see a row even when a part didn't match
        if (!applicableParts.length) {
          return <div className>{row.original.PartNumbers}</div>;
        }

        row.original.applicableParts = applicableParts;

        return <div className="part">{applicableParts.join(' & ')}</div>;
      },
    },
    { Header: 'Coupon', className: 'text-center', accessor: 'CouponCode' },
    // { Header: 'Print', accessor: 'PrintCode' },
    // { Header: 'Campaign', accessor: 'CampaignCode' },
    // { Header: 'Name', accessor: 'Name' },
    { Header: 'Category', className: 'text-center', accessor: 'OfferCategory' },
    { Header: 'Type', className: 'text-center', accessor: 'OfferType' },
    // { Header: 'Amount Type', accessor: 'AmountType' },
  ];

  const getOffers = ({ page, pageSize, sorted }) => {
    const search = {
      pageSize,
      page: page + 1,
      ...params,
    };

    // May not even be sortable
    if (sorted && sorted[0]) {
      const k = sorted[0].id;
      search.sortBy = `${k.charAt(0).toLowerCase()}${k.slice(1)}`;
      search.sortDir = sorted[0].desc ? 'DESC' : 'ASC';
    }

    setLoading(true);

    const request = customerId ? fetchCustomerOffers(customerId, search) : fetchPublicOffers(search);

    if (setTitle) {
      setTitle(customerId ? `Offers for Customer ${customerId}` : 'Public Offers');
    }

    request
      .then(response => {
        const { TotalResults, PageSize, CurrentPage, TotalPage, Results } = response.data;

        if (TotalPage > 1) {
          setShowPagination(true);
        }

        setList(Results);
        setLoading(false);
        setPage(CurrentPage - 1);
        setPageSize(PageSize);
        setTotal(TotalResults);
        setTotalPages(TotalPage);

        const selectedSeed = { ...selected };

        if (Array.isArray(Results) && Results.length > 0) {
          for (const offer of Results) {
            const offerId = offer.OfferUniqueId;
            if (initialOffersSelected.includes(offerId)) {
              selectedSeed[offerId] = offer;
            }
          }
          setSelected(selectedSeed);
        }
      })
      .catch(e => {
        setLoading(false);
        const { response } = e;

        if (response && response.status === 404) {
          setTotal(0);
          setTotalPages(0);
          // setError('No offers for this customer');
        } else {
          setError('Error getting customer offers');
        }
      });
  };

  const renderTable = () => {
    return (
      <ReactTable
        className="-striped -highlight"
        columns={columns}
        data={list}
        defaultPageSize={pageSize}
        loading={loading}
        manual
        onFetchData={state => getOffers({ ...state })}
        page={page}
        pageSize={pageSize}
        pageSizeOptions={[2, 5, 10, 25]}
        pages={totalPages}
        sortable
        showPagination={showPagination}
        style={{
          height: '470px',
        }}
      />
    );
  };

  const renderFooter = () => {
    const primaryAction = onSelect ? (
      <Button
        variant="primary"
        onClick={() => onSelect(Object.keys(selected).map(k => selected[k]))}
        disabled={!selectedCount || redeeming}
      >
        Apply Selected
      </Button>
    ) : (
      <Button variant="primary" onClick={() => onRedeem()} disabled={!selectedCount || redeeming}>
        {redeeming === true ? (
          <div className="button-loading">
            <i className="zmdi zmdi-settings zmdi-hc-spin" style={{ color: '#FFF', fontSize: '15px' }} /> Please Wait
          </div>
        ) : (
          'Redeem'
        )}
      </Button>
    );

    return (
      <div className="footer">
        {selectedCount > 0 && (
          <div className="selected-amount">
            Total <span>{Validator.sanitize('number', getSelectedAmount(), { precision: 2 })}</span>
          </div>
        )}
        <div className="toolbar float-right">{primaryAction}</div>
        <div className="clearfix" />
      </div>
    );
  };

  if (error) {
    return <FileNotFound className="error">{error}</FileNotFound>;
  }

  return (
    <div className="loyalty-list offer-list">
      <div className="current-search" onClick={onQueryClick}>
        <span className="current-label">Query</span>
        {query.length === 0 ? (
          <div className="search-data">
            {customerId ? `Showing All Offers for Customer ${customerId}` : 'Showing Public Offers'}
          </div>
        ) : (
          <>
            {query.map(q => {
              return (
                <div className="search-data" key={q.label}>
                  {q.value === true ? (
                    <strong>{q.label}</strong>
                  ) : (
                    <>
                      {q.label}: <strong>{q.value}</strong>
                    </>
                  )}
                </div>
              );
            })}
          </>
        )}
        {totalPages !== -1 && (
          <div className="total">
            <strong>{total}</strong>
          </div>
        )}
      </div>
      {renderTable()}
      {renderFooter()}
    </div>
  );
};

OfferList.propTypes = {
  customerId: PropTypes.number,
  initialOffersSelected: PropTypes.array,
  invoiceNumber: PropTypes.string,
  onQueryClick: PropTypes.func,
  onSelect: PropTypes.func,
  params: PropTypes.object,
  query: PropTypes.array,
};

export default OfferList;
